export default {
  locale: "es-MX"
  , nodata: "No hay opciones para seleccionar"
  , copyright: "1.0.0"
  , sistema: "Talent Acquisition"
  , system: "Talent Acquisition"
  , ok: "OK"
  , cancel: "Cancelar"
  , clear: "Limpiar"
  , desde: "Desde"
  , hasta: "Hasta"
  , clave: "Clave"
  , email: "Email"
  , status: "Estatus"
  , url: "URL"
  , usuario: "Usuario"
  , puerto: "Puerto"
  , directorio: "Directorio"
  , contrasena: "Contraseña"
  , audit: "Auditoría"
  , loading: "Cargando . . ."
  , save: "Guardar"
  , update: "Actualizar"
  , privileges: "Privilegios"
  , fecha: "Fecha"
  , aplicar: "Aplicar"
  , search: "Buscar"
  , proceso: "Proceso"
  , accion: "Acción"
  , detail: "Detalles"
  , edit: "Editar"
  , disable: "Desactivar"
  , delete: "Eliminar"
  , report: "Generar Reporte"
  , print: "Imprimir"
  , records: "Registros"
  , add: "Agregar"
  , remove: "Quitar"
  , download: "Descargar Archivo"
  , close: "Cerrar"
  , today: "Hoy"
  , back: "Regresar al listado"
  , next: "Siguiente"
  , prev: "Anterior"
  , yes: "Si"
  , no: "No"
  , imgsel: "Selecciona una imagen"
  , imgrem: "Remover imagen"
  , expandAll: "Expandir todo"
  , colapseAll: "Contraer todo"
  , filepond: {
    select: "Arrastra el archivo aquí o Selecciona un archivo"
    , labelFileLoading: "Cargando"
    , labelFileProcessing: "Subiendo"
    , labelFileProcessingComplete: "Carga completa"
    , labelTapToRetry: "Volver a intentar"
    , labelidle: "Arrastra el archivo aquí o <span class='filepond--label-action'> Selecciona archivo </span>"
    , labelInvalidField: "El tipo de archivo no es valido"
    , labelFileProcessingAborted: "Cancelar"
    , labelTapToCancel: "Cancelar"
    , labelFileLoadError: "Ocurrió un error, intente nuevamente o compruebe sus permisos"
    , labelFileProcessingError: "Ocurrió un error, verifique la información del archivo."
    , labelFileTypeNotAllowed: "Tipo de archivo inválido"
    , labelMaxFileSizeExceeded: "El archivo excede el tamaño máximo permitido"
    , labelMaxVideoSizeExceeded: "El video excede el tamaño máximo permitido"
    , labelMaxTotalFileSizeExceeded: "Los archivos exceden el total de tamaño máximo permitido"
    , labelMaxFileSize: "El tamaño máximo permitido es de {filesize}"
    , labelMaxVideoSize: "El tamaño máximo de video permitido es de {filesize}"
    , labelMaxFiles: "Solo puedes seleccionar hasta {0} archivo(s)"
    , labelNoPermission: "No cuentas con permisos para cargar archivos {0}"
    , labelNameCharacters: "El nombre no debe contener caracteres especiales"
    , labelNameMaxChars: "El nombre no debe contener mas de {0} caracteres"
    , labelButtonDownloadItem: "Descargar Archivo"
    , labelButtonPrivateItem: "Marcar archivo como privado"
    , fileValidateTypeLabelExpectedTypes: "Archivos válidos {0}"
    , fileNameInvalid: "El nombre del archivo contiene carácteres inválidos: {c} "
  }
  , swal: {
    common: {
      confirmButtonColor: "#0077BC"
      , cancelButtonColor: "#e7eaec"
      , confirmButtonText: "Aceptar"
      , cancelButtonText: "Cancelar"
    }
    , clear: {
      title: "¿Está segur@?"
      , text: "No se guardarán los cambios"
      , type: "warning"
    }
    , registroTalentoSwal: {
      title: "¿Ha finalizado?"
      , text: "Su solicitud será enviada al equipo de Nexion Solutions"
      , type: "warning"
    }
    , tokenTalentoSwal: {
      title: "Atención"
      , text: "Le hemos enviado un token de seguridad a su correo para validar la autenticidad. Escriba el token recibido a continuación."
      , type: "info"
    }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/commons.js